import React, { useState , useEffect } from 'react';
import { Row, Container, Col, Form, Button, Modal, Spinner, Nav, Tab } from "react-bootstrap";
import Multiselect from 'multiselect-react-dropdown';
import N from '../lib/Network'
import AC from '../lib/AppConsts'
import S from '../lib/Security'
import axios from 'axios'
import C from '../lib/Confg'
import swal from 'sweetalert'
import Loader from "./Loader";
var CryptoJS = require("crypto-js");

const AddTenantUser = ({ showUserPopup, closeModal}) => {
    const [key,setKey]= useState("first");
    const [costCenterData,setCostCenterData] = useState(''); 
    const [profitCenterData,setProfitCenterData] = useState('');
    const [unitData,setUnitData] = useState('');
    const [locationBasedOnZoneData,setLocationBasedOnZoneData] = useState('');
    const [designationData,setDesignationData] = useState('');
    const [zoneData,setZoneData] = useState('');
    const [subZoneData,setSubZoneData] = useState('');
    const [ReportingData,setReportingData] = useState('');
    const [approvalSeniorityData,setApprovalSeniorityData] = useState('');
    const [assignRolesData,setAssignRolesData] = useState('');
    const [companyBasedOnTenantData,setCompanyBasedOnTenantData] = useState('');
    const [roleBasedOnCompanyData,setRoleBasedOnCompanyData] = useState('');
    const [employeeStatus,setEmployeeStatus] = useState('');
    const [zoneName,setZoneName] = useState('');
    const [zoneId,setZoneId] = useState('');
    const [subZoneName,setSubZoneName] = useState('');
    const [subZoneId,setSubZoneId] = useState('');
    const [employeeCode,setEmployeeCode] = useState('');
    const [userId,setUserId] = useState('');
    const [firstName,setFirstName] = useState('');
    const [middleName,setMiddleName] = useState('');
    const [lastName,setLastName] = useState('');
    const [contactNo,setContactNo] = useState('');
    const [statusValue,setStatusValue] = useState('');
    const [statusId,setStatusId] = useState('');
    const [companyName,setCompanyName] = useState('');
    const [companyId,setCompanyId] = useState('');
    const [emailId,setEmailId] = useState('');
    const [costCenterName,setCostCenterName] = useState('');
    const [costCenterId,setCostCenterId] = useState('');
    const [profitCenterName,setProfitCenterName] = useState('');
    const [profitCenterId,setProfitCenterId] = useState('');
    const [unitName,setUnitName] = useState('');
    const [unitId,setUnitId] = useState('');
    const [designationCode,setDesignationCode] = useState('');
    const [designationId,setDesignationId] = useState('');
    const [locationName,setLocationName] = useState('');
    const [locationId,setLocationId] = useState('');
    const [functionalReportingName,setFunctionalReportingName] = useState('');
    const [functionalReportingId,setFunctionalReportingId] = useState('');
    const [adminReportingName,setAdminReportingName] = useState('');
    const [adminReportingId,setAdminReportingId] = useState('');
    const [approvalSeniorityName,setApprovalSeniorityName] = useState('');
    const [approvalSeniorityId,setApprovalSeniorityId] = useState('');
    const [GRNatHO,setGRNatHO] = useState('');
    const [GRNatZone,setGRNatZone] = useState('');
    const [GRNatLocation,setGRNatLocation] = useState('');
    const [role,setRole] = useState([ ]);
    const [errors,setErrors] = useState({});
    var [zone] = useState();
    var [tenant] = useState();
    var [company] = useState();
    const current = new Date();
    const date = `${current.getDate()}/${current.getMonth()+1}/${current.getFullYear()}`;
    const [showLoader, setShowLoader] = useState(false);
    useEffect(() => { 
        getKeys();
        fetchCompanyBasedOnTenantId();
        fetchEmployeeStatusData();
        
    }, [])
    const showLoaderPopup = () => { setShowLoader(true) }
    const closeLoader = () => { setShowLoader(false) }
    function getKeys(){
        if(S.getPrivateKey() == '' && S.getPublicKey() == ''){
            N.getRSAApi('/getRsaKeys')
            .then(res => {
                let resObj = JSON.parse(res.data);
                let resJson = JSON.parse(resObj.responseJson);
                if(resJson.privateKey && resJson.publicKey){
                    let newKey = CryptoJS.enc.Utf8.parse('NexStepPrivacy@#');
                    // Decrypt
                    var privateKeyBytes = CryptoJS.AES.decrypt(resJson.privateKey, newKey, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7});
                    S.privateKey = privateKeyBytes.toString(CryptoJS.enc.Utf8);
                    console.log("privateKey:"+JSON.stringify(S.privateKey))
        
                    var publicKeyBytes = CryptoJS.AES.decrypt(resJson.publicKey, newKey, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7});
                    S.publicKey = publicKeyBytes.toString(CryptoJS.enc.Utf8);
                    console.log("publicKey:"+JSON.stringify(S.publicKey))

                    fetchCompanyBasedOnTenantId();
                    fetchEmployeeStatusData();
                    
                }
            })
            .catch(err => {
                console.log("Error : "+err);
            });
        }
    }
    const handleNextTabClick  = (key) => { setKey(key) };
    const handlePreviousTabClick  = (key) => { setKey(key); };
    const closePopup = () => { closeModal();  clearState(); handleNextTabClick("first");}
    const validatePersonalDetails = () =>{
        let formIsValid = true;
        let err = {};
        var alphawithspace = new RegExp(/^[A-Za-z]+$/i);
        var PhPattern = new RegExp(/^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/i);
        if(employeeCode ==="" || employeeCode.length<=0){
            err["employeeCode"] = "Employee Code cannot be empty";
            formIsValid= false;
        }
        if(userId ==="" || userId.length<=0){
            err["userId"] = "User Id cannot be empty";
            formIsValid= false;
        }
        if(firstName ==="" || firstName.length<=0){
            err["firstName"] = "First Name cannot be empty";
            formIsValid= false;
        }else if(!alphawithspace.test(firstName)){
            err["firstName"] = "Special character and Numeric value are not allowed in Employee Name";
          formIsValid= false;
        }
        
        if(lastName ==="" || lastName.length<=0){
            err["lastName"] = "Last Name cannot be empty";
            formIsValid= false;
        }else if(!alphawithspace.test(lastName)){
            err["lastName"] = "Special character and Numeric value are not allowed in Employee Name";
          formIsValid= false;
        }
        if((!alphawithspace.test(middleName)) && (middleName!= "")){
            err["middleName"] = "Special character and Numeric value are not allowed in Employee Name";
          formIsValid= false;
        }
        if(contactNo ==="" || contactNo.length<=0){
            err["contactNo"] = "Contact No cannot be empty";
            formIsValid= false;
        }else if(contactNo.length!= 10){
            err["contactNo"] = "Please enter valid Contact No";
            formIsValid= false;
        }else if(!PhPattern.test(contactNo)){
            err["contactNo"] = "Please enter valid Contact No ";
            formIsValid= false;
        }
        if(statusValue ==="" || statusValue ===undefined){
            err["status"] = "Please select status";
            formIsValid= false;
        }
        setErrors(err);
            return formIsValid;
    }
    const personalDetailsSave = () =>{
        let isThisValidForm = false;
        if(validatePersonalDetails()){
            isThisValidForm = true;
        }
        if(isThisValidForm){
            handleNextTabClick("second");
        }
    }
    const validateCompanyDetails = () =>{
        let formIsValid = true;
        let err = {};
        var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
        if(companyName ==="" || companyName.length<=0){
            err["companyName"] = "Company Name cannot be empty";
            formIsValid= false;
        }if(emailId ==="" || emailId.length<=0){
            err["emailId"] = "Email Id cannot be empty";
            formIsValid= false;
        }else if(!pattern.test(emailId)){
            err["emailId"] = "Please enter valid email address.";
            formIsValid= false;
        }if(costCenterName ==="" || costCenterName === undefined){
            err["costCenter"] = "Please Select Cost Center ";
            formIsValid= false;
        }if(profitCenterName ==="" || profitCenterName === undefined){
            err["profitCenter"] = "Please Select Profit Center ";
            formIsValid= false;
        }if(unitName ==="" || unitName === undefined){
            err["unit"] = "Please Select Unit ";
            formIsValid= false;
        }if(designationCode ==="" || designationCode === undefined){
            err["designation"] = "Please Select Designation ";
            formIsValid= false;
        }
        // }if(zoneName ==="" || zoneName === undefined){
        //     err["zone"] = "Please Select Zone ";
        //     formIsValid= false;
        // }if(locationName ==="" || locationName === undefined){
        //     err["location"] = "Please Select Location ";
        //     formIsValid= false;
        // }
        setErrors(err);
            return formIsValid;
    }
    const companyDetailsSave = () =>{
        let isThisValidForm = false;
        if(validateCompanyDetails()){
        isThisValidForm = true;
        }
        if(isThisValidForm){
            handleNextTabClick("third");
        }
    }
    const validateReportingDetails = () =>{
        let formIsValid = true;
        let err = {};
        if(GRNatHO ==="" || GRNatHO === undefined || GRNatHO === "0"){
            err["GRNatHO"] = "Please Select GRN at HO";
            formIsValid= false;
        }
        if(GRNatZone ==="" || GRNatZone === undefined || GRNatZone === "0"){
            err["GRNatZone"] = "Please Select GRN at Zone ";
            formIsValid= false;
        }
        if(GRNatLocation ==="" || GRNatLocation === undefined || GRNatLocation === "0"){
            err["GRNatLocation"] = "Please Select GRN at Location";
            formIsValid= false;
        }
        if (ReportingData?.Payload?.Message === "No User Found") {
            err["functionalReporting"] = " ";
            formIsValid= true;
        }else{
            if(functionalReportingName ==="" || functionalReportingName === undefined){
                err["functionalReporting"] = "Please Select Functional Reporting ";
                formIsValid= false;
            }
        }
        if (ReportingData?.Payload?.Message === "No User Found") {
            err["adminReporting"] = " ";
            formIsValid= true;
        }else{
        if(adminReportingName ==="" || adminReportingName === undefined){
            err["adminReporting"] = "Please Select Admin Reporting ";
            formIsValid= false;
        }}
        if(approvalSeniorityName ==="" || approvalSeniorityName === undefined){
            err["approvalSeniority"] = "Please Select Approval Seniority ";
            formIsValid= false;
        }
        setErrors(err);
            return formIsValid;
    }
    const reportingDetailsSave = () =>{
        let isThisValidForm = false;
        if(validateReportingDetails()){
            isThisValidForm = true;
        }
        if(isThisValidForm){
            handleNextTabClick("fourth");
        }
    }
    const validateDetailsForP2P = () =>{
        let formIsValid = true;
        let err = {};
        if (roleBasedOnCompanyData?.Payload?.Message === "No User Found") {
            err["role"] = " ";
            formIsValid= true;
        }else{
            if(role.length<=0){
                err["role"] = "Select at least One Role";
                formIsValid= false;
            }
        }
        setErrors(err);
            return formIsValid;
    }
    const DetailsForP2PSave = () =>{
        let isThisValidForm = false;
        if(validateReportingDetails()){
            isThisValidForm = true;
        }
        if(isThisValidForm){
            handleNextTabClick("fourth");
        }
    }
    const onSelect =  (data) => {
        errors["role"] = "";
        setRole(data);
    }
    const onRemove =  (data) => {
        errors["role"] = "";
        setRole(data);
    }
    var tenant = {};
    const fetchCostCenterData = (compId) => {
        company = {companyId:compId};
        N.postApi('getCostCenters',company)
        .then(res => {
            var response = S.getDecryptedJSON(res);
            setCostCenterData(JSON.parse(response.responseJson))
        })
    }
    const fetchProfitCenterData = (compId) => {
        company = {companyId:compId};
        N.postApi('getProfitCenters',company)
        .then(res => {
            var response = S.getDecryptedJSON(res);
            setProfitCenterData(JSON.parse(response.responseJson))
        })
    }
    const fetchUnitData = (compId) => {
        company = {companyId:compId};
        N.postApi('getOrgUnits',company)
        .then(res => {
            var response = S.getDecryptedJSON(res);
            setUnitData(JSON.parse(response.responseJson))
        })
    }
    const fetchReportingData = (compId) => {
        company = {companyId:compId};
        N.postApi('getEmployeeLists',company)
        .then(res => {
            var response = S.getDecryptedJSON(res);
            setReportingData(JSON.parse(response.responseJson))
        })
    }
    const fetchApprovalSeniorityData = (compId) => {
        company = {companyId:compId};
        N.postApi('getGradeLists',company)
        .then(res => {
            var response = S.getDecryptedJSON(res);
            setApprovalSeniorityData(JSON.parse(response.responseJson))
        })
    }
    const fetchDesignationData = (compId) => {
        company = {companyId:compId};
        N.postApi('getDesignationMstLists',company)
        .then(res => {
            var response = S.getDecryptedJSON(res);
            setDesignationData(JSON.parse(response.responseJson))
        })
    }
    const fetchZoneData = (compId) => {
        company = {companyId:compId};
        N.postApi('getZoneMsts',company)
        .then(res => {
            var response = S.getDecryptedJSON(res);
            setZoneData(JSON.parse(response.responseJson))
        })
    }
    const fetchEmployeeStatusData = () => {
        N.getApi('getEmployeeStatuss')
        .then(res => {
            var response = S.getDecryptedJSON(res);
            setEmployeeStatus(JSON.parse(response.responseJson))
        })
    }
    const fetchLocationBasedOnZone = (zoneId) =>{
        zone = {
            zoneId:zoneId
        };
        N.postApi('getLocationBasedOnZones',zone)
        .then(res => {
            var response = S.getDecryptedJSON(res);
            setLocationBasedOnZoneData(JSON.parse(response.responseJson))
        })
        .catch(err => {
            console.log("Error : "+err);
        });
    }
    const fetchCompanyBasedOnTenantId = () =>{
        tenant = {tenantId:localStorage.getItem("tenantId")};
        console.log("tenant"+tenant)
        N.postApi('getCompanyByTenants',tenant)
        .then(res => {
            var response = S.getDecryptedJSON(res);
            setCompanyBasedOnTenantData(JSON.parse(response.responseJson))
        })
        .catch(err => {
            console.log("Error : "+err);
        });
    }
    const fetchRoleBasedOnCompany = (compId) =>{
        company = {
            companyId:compId
        };
        N.postApi('getActivityByComps',company)
        .then(res => {
            var response = S.getDecryptedJSON(res);
            setRoleBasedOnCompanyData(JSON.parse(response.responseJson))
        })
        .catch(err => {
            console.log("Error : "+err);
        });
    }
    const handleChange = (event) => {
        if (event.target.name === 'employeeCode') {
            errors["employeeCode"] ="";
            setEmployeeCode( event.target.value );
        }
        if (event.target.name === 'userId') {
            errors["userId"] ="";
            setUserId( event.target.value );
        }
        if (event.target.name === 'firstName') {
            errors["firstName"] ="";
            setFirstName( event.target.value );
        }
        if (event.target.name === 'middleName') {
            errors["middleName"] ="";
            setMiddleName( event.target.value );
        }
        if (event.target.name === 'lastName') {
            errors["lastName"] ="";
            setLastName( event.target.value );
        }
        if (event.target.name === 'contactNo') {
            errors["contactNo"] ="";
            setContactNo( event.target.value );
        }
        if (event.target.name === 'status') {
            if(event.target.value != 0){
                errors["status"] ="";
                const statusMST = employeeStatus?.Payload?.employeeStatusList?.filter((e) => e.employeeStatusId === event.target.value && e);
                setStatusValue(statusMST[0].statusValue);
                setStatusId(statusMST[0].employeeStatusId);
            }else{
                errors["status"] ="";
                setStatusValue();
                setStatusId();
            }
        }
        if (event.target.name === 'companyName') {
            if(event.target.value != 0){
                errors["companyName"] ="";
                const companyMST = companyBasedOnTenantData?.Payload?.companyMstList?.filter((e) => e.companyId === event.target.value && e);
                setCompanyName(companyMST[0].companyName);
                setCompanyId(companyMST[0].companyId);
                const compId = companyMST[0].companyId;
                fetchRoleBasedOnCompany(compId);
                fetchProfitCenterData(compId);
                fetchCostCenterData(compId);
                fetchUnitData(compId);
                fetchReportingData(compId);
                fetchApprovalSeniorityData(compId);
                fetchDesignationData(compId);
                fetchZoneData(compId);
            }else{
                errors["companyName"] ="";
                setCompanyName();
                setCompanyId();
            }
        }
        if (event.target.name === 'emailId') {
            errors["emailId"] ="";
            setEmailId( event.target.value );
        }
        if (event.target.name === 'costCenter') {
            if(event.target.value != 0){
                errors["costCenter"] ="";
                const costCenterMST = costCenterData?.Payload?.costCenterList?.filter((e) => e.costCenterId === event.target.value && e);
                setCostCenterName(costCenterMST[0].costCenterName);
                setCostCenterId(costCenterMST[0].costCenterId);
            }else{
                errors["costCenter"] ="";
                setCostCenterName();
                setCostCenterId();
            }
        }
        if (event.target.name === 'profitCenter') {
            if(event.target.value != 0){
                errors["profitCenter"] ="";
                const profitCenterMST = profitCenterData?.Payload?.profitCenterList?.filter((e) => e.profitCenterId === event.target.value && e);
                setProfitCenterName(profitCenterMST[0].profitCenterName);
                setProfitCenterId(profitCenterMST[0].profitCenterId);
            }else{
                errors["profitCenter"] ="";
                setProfitCenterName();
                setProfitCenterId();
            }
        }
        if (event.target.name === 'unit') {
            if(event.target.value != 0){
                errors["unit"] ="";
                const unitMST = unitData?.Payload?.orgUnitList?.filter((e) => e.orgUnitId === event.target.value && e);
                setUnitName(unitMST[0].orgUnitName);
                setUnitId(unitMST[0].orgUnitId);
                }else{
                errors["unit"] ="";
                setUnitName();
                setUnitId();
                }
        }
        if (event.target.name === 'designation') {
            if(event.target.value != 0){
                errors["designation"] ="";
                const designationMST = designationData?.Payload?.designationList?.filter((e) => e.designationId === event.target.value && e);
                setDesignationCode(designationMST[0].designationCode);
                setDesignationId(designationMST[0].designationId);
            }else{
                errors["designation"] ="";
                setDesignationCode();
                setDesignationId();
            }
        }
        if (event.target.name === 'location') {
            if(event.target.value != 0){
                errors["location"] ="";
                const locationMST = locationBasedOnZoneData?.Payload?.locationMstList?.filter((e) => e.locationId === event.target.value && e);
                setLocationName(locationMST[0].locationName);
                setLocationId(locationMST[0].locationId);
            }else{
                errors["location"] ="";
                setLocationName();
                setLocationId();
            }
        }
        if (event.target.name === 'GRNatHO') {
            errors["GRNatHO"] ="";
            setGRNatHO( event.target.value );
        }
        if (event.target.name === 'GRNatZone') {
            errors["GRNatZone"] ="";
            setGRNatZone( event.target.value );
        }
        if (event.target.name === 'GRNatLocation') {
            errors["GRNatLocation"] ="";
            setGRNatLocation( event.target.value );
        }
        if (event.target.name === 'functionalReporting') {
            if(event.target.value != 0){
                errors["functionalReporting"] ="";
                const functionalReportingMST = ReportingData?.Payload?.employeeList?.filter((e) => e.employeeId === event.target.value && e);
                setFunctionalReportingName(functionalReportingMST[0].employeeName);
                setFunctionalReportingId(functionalReportingMST[0].employeeId);
                }else{
                errors["functionalReporting"] ="";
                setFunctionalReportingName();
                setFunctionalReportingId();
                }
        }
        if (event.target.name === 'adminReporting') {
            if(event.target.value != 0){
                errors["adminReporting"] ="";
                const adminReportingMST = ReportingData?.Payload?.employeeList?.filter((e) => e.employeeId === event.target.value && e);
                setAdminReportingName(adminReportingMST[0].employeeName);
                setAdminReportingId(adminReportingMST[0].employeeId);
            }else{
                errors["adminReporting"] ="";
                setAdminReportingName();
                setAdminReportingId();
            }
        }
        if (event.target.name === 'approvalSeniority') {
            if(event.target.value != 0){
                errors["approvalSeniority"] ="";
                const approvalSeniorityMST = approvalSeniorityData?.Payload?.gradeList?.filter((e) => e.gradeId === event.target.value && e);
                setApprovalSeniorityName(approvalSeniorityMST[0].gradeName);
                setApprovalSeniorityId(approvalSeniorityMST[0].gradeId);
            }else{
                errors["approvalSeniority"] ="";
                setAdminReportingName();
                setAdminReportingId();
            }
        }
        if (event.target.name === 'zone') {
            if(event.target.value != 0){
                errors["zone"] ="";
                const zoneMST = zoneData?.Payload?.zoneMstList?.filter((e) => e.zoneMstId === event.target.value && e);
                setZoneName(zoneMST[0].zoneName);
                setZoneId(zoneMST[0].zoneMstId);
                setSubZoneName(zoneMST[0].zoneName);
                setSubZoneId(zoneMST[0].zoneMstId)
                fetchLocationBasedOnZone(zoneMST[0].zoneMstId)
            }else{
                errors["zone"] ="";
                setZoneName();
                setZoneId();
                setSubZoneName();
                setSubZoneId()
            }
        }
    }

    const saveTabDetails = (event) => {
            let isThisValidForm = false;
        if(validateDetailsForP2P()){
            isThisValidForm = true;
        }
        if(isThisValidForm){
            document.getElementById("saveTenantUser").disabled = true;
            showLoaderPopup();
        var TabObj = {
            Employee_Code:employeeCode,
            User_ID: userId,
            First_Name: firstName,
            Middle_Name: middleName,
            Last_Name: lastName,
            Email_ID: emailId,
            Contact_No: contactNo,
            Cost_Center_ID: costCenterId,
            Profit_Center_ID: profitCenterId,
            Unit_Id: unitId,
            Approver_Seniority: approvalSeniorityId,
            Functional_Reporting_Id: functionalReportingId,
            Admin_Reporting_Id: adminReportingId,
            Designation_Id: designationId,
            Status: statusId,
            Zone_Id: zoneId,
            Location_Id: locationId,
            Sub_Zone_id: subZoneId,
            GRN_creation_rights_at_HO: GRNatHO,
            GRN_creation_rights_at_zone: GRNatZone,
            GRN_creation_rights_at_location: GRNatLocation,
            action: AC.ACTION_SAVE,
            employee_Id: "0",
            createdById:localStorage.getItem("userId"),
            createdDate: date,
            tenantId: localStorage.getItem("tenantId"),
            //added below for tenantName in p2p db
            tenantName: localStorage.getItem("tenantName"),
            companyId:companyId,
            role : role,
        }   
        return N.postApi('createTenantUser',TabObj)
            .then(response => {
                var res = S.getDecryptedJSON(response);
                if(res.responseStatus === AC.STATUS_SUCCESS){
                    closeLoader();
                    swal("Success!", "Record Saved Suceesfully", "success", { buttons: false,timer: 2000,});
                    closePopup();
                    setTimeout(() => {
                        window.location.reload(true); 
                    }, 2000);
                }else{
                    closeLoader();
                    swal("Error!", "Record Not Saved", "warning", { buttons: false,timer: 2000,});
                    document.getElementById("saveTenantUser").disabled = false;
                }
            })
            .catch(err => {
                console.log("Error : " + err);
            });
        }
    }
    const clearState = () => {
        setEmployeeCode(''); setUserId(''); setFirstName(''); setMiddleName(''); setLastName(''); setEmailId(''); setContactNo(''); setCostCenterId(''); setCostCenterName(''); setProfitCenterId(''); 
        setProfitCenterName(''); setUnitId(''); setUnitName(''); setApprovalSeniorityId(''); setApprovalSeniorityName(''); setFunctionalReportingId(''); setFunctionalReportingName('');
        setAdminReportingId(''); setAdminReportingName(''); setDesignationId(''); setDesignationCode(''); setStatusId(''); setStatusValue(''); setZoneId('');setErrors({});
        setZoneName(''); setLocationId(''); setLocationName(''); setSubZoneId(''); setSubZoneName(''); setGRNatHO(''); setGRNatZone(''); setGRNatLocation(''); setCompanyId(''); setCompanyName(''); setRole([]);
    }
    return (
        <Modal id="addUser" show={showUserPopup} animation={true} size="xl">
            <Modal.Header closeButton onClick={() => closePopup()}>
                <Modal.Title><h5 className="headerTitle">Create Tenant User</h5></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container fluid>
                    <Tab.Container id="left-tabs-example" onChange={handleNextTabClick} activeKey={key}>
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <div className="multi-step">
                                    <Nav variant="pills" className="nav-justified">
                                        <Nav.Item>
                                            <Nav.Link className="item-wrap" eventKey="first"><p className="item-title disabled">Personal Details</p></Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link className="item-wrap" eventKey="second"><p className="item-title disabled">Company Details</p></Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link className="item-wrap" eventKey="third"><p className="item-title disabled">Reporting Details</p></Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link className="item-wrap" eventKey="fourth"><p className="item-title disabled">Details for P2P</p></Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </div>
                            </Col>
                            <Col xs={12} md={12} lg={12} className="mt-4">
                                <Tab.Content>
                                    <Tab.Pane eventKey="first">
                                        <Row>
                                            <Col xs={6} md={3} lg={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Employee Code</Form.Label>
                                                    <Form.Control name="employeeCode" type="text" className="form-control" placeholder="Enter Employee Code" onChange={handleChange}/>
                                                    <div className="invalid-feedback">{errors["employeeCode"]}</div>
                                                </Form.Group>
                                            </Col>
                                            <Col xs={6} md={3} lg={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>User Id</Form.Label>
                                                    <Form.Control name="userId" type="text" className="form-control" placeholder="Enter User Id" onChange={handleChange}/>
                                                    <div className="invalid-feedback">{errors["userId"]}</div>
                                                </Form.Group>
                                            </Col>
                                            <Col xs={6} md={3} lg={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>First Name</Form.Label>
                                                    <Form.Control name="firstName" type="text" className="form-control" placeholder="Enter First Name" onChange={handleChange}/>
                                                    <div className="invalid-feedback">{errors["firstName"]}</div>
                                                </Form.Group>
                                            </Col>
                                            <Col xs={6} md={3} lg={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Middle Name</Form.Label>
                                                    <Form.Control name="middleName" type="text" className="form-control" placeholder="Enter Middle Name" onChange={handleChange}/>
                                                    <div className="invalid-feedback">{errors["middleName"]}</div>
                                                </Form.Group>
                                            </Col>
                                            <Col xs={6} md={3} lg={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Last Name</Form.Label>
                                                    <Form.Control name="lastName" type="text" className="form-control" placeholder="Enter Last Name" onChange={handleChange}/>
                                                    <div className="invalid-feedback">{errors["lastName"]}</div>
                                                </Form.Group>
                                            </Col>
                                            <Col xs={6} md={3} lg={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Contact No.</Form.Label>
                                                    <Form.Control name="contactNo" type="number" className="form-control" placeholder="Enter Contact No." onChange={handleChange}/>
                                                    <div className="invalid-feedback">{errors["contactNo"]}</div>
                                                </Form.Group>
                                            </Col>
                                            <Col xs={6} md={3} lg={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Employee Status</Form.Label>
                                                    <Form.Select className="form-control" name="status" onChange={handleChange}>
                                                        <option value="0">- Select Employee Status -</option>
                                                        {employeeStatus?.Payload?.employeeStatusList?.map((result) => {
                                                        return (
                                                            <option value={result.employeeStatusId}>{result.statusValue}</option>
                                                        )})}
                                                    </Form.Select>
                                                    <div className="invalid-feedback">{errors["status"]}</div>
                                                </Form.Group>
                                            </Col>
                                            <Col xs={12} md={12} lg={12} className="text-right mt-2">
                                                <Button type="button" className="btn btn-sm btn-primary dt shadow-sm" onClick={()=> {personalDetailsSave();}}>Next</Button>
                                            </Col>
                                        </Row>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="second">
                                        <Row>
                                            <Col xs={6} md={3} lg={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Company Name</Form.Label>
                                                    <Form.Select name="companyName" className="form-control" onChange={handleChange}>
                                                        <option value="0">- Select Company Name -</option>
                                                        {companyBasedOnTenantData?.Payload?.companyMstList?.map((result) => {
                                                        return (
                                                            <option value={result.companyId}>{result.companyName}</option>
                                                        )})} 
                                                    </Form.Select>
                                                    <div className="invalid-feedback">{errors["companyName"]}</div>
                                                </Form.Group>
                                            </Col>
                                            <Col xs={6} md={3} lg={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Email Id</Form.Label>
                                                    <Form.Control name="emailId" type="text" className="form-control" placeholder="Enter Email Id" onChange={handleChange}/>
                                                    <div className="invalid-feedback">{errors["emailId"]}</div>
                                                </Form.Group>
                                            </Col>
                                            <Col xs={6} md={3} lg={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Cost Center</Form.Label>
                                                    <Form.Select className="form-control" name="costCenter" onChange={handleChange}>
                                                        <option value="0">- Select Cost Center-</option>
                                                        {costCenterData?.Payload?.costCenterList?.map((result) => {
                                                            return (
                                                                <option value={result.costCenterId}>{result.costCenterName}</option>
                                                            )}
                                                        )} 
                                                    </Form.Select>
                                                    <div className="invalid-feedback">{errors["costCenter"]}</div>
                                                </Form.Group>
                                            </Col>
                                            <Col xs={6} md={3} lg={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Profit Center</Form.Label>
                                                    <Form.Select className="form-control" name="profitCenter" onChange={handleChange}>
                                                        <option value="0">- Select Profit Center -</option>
                                                        {profitCenterData?.Payload?.profitCenterList?.map((result) => {
                                                            return (
                                                                <option value={result.profitCenterId}>{result.profitCenterName}</option>
                                                            )}
                                                        )}
                                                    </Form.Select>
                                                    <div className="invalid-feedback">{errors["profitCenter"]}</div>
                                                </Form.Group>
                                            </Col>
                                            <Col xs={6} md={3} lg={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Unit</Form.Label>
                                                    <Form.Select className="form-control" name="unit" onChange={handleChange}>
                                                        <option value="0">- Select Unit -</option>
                                                        {unitData?.Payload?.orgUnitList?.map((result) => {
                                                            return (
                                                                <option value={result.orgUnitId}>{result.orgUnitName}</option>
                                                            )}
                                                        )}
                                                    </Form.Select>
                                                    <div className="invalid-feedback">{errors["unit"]}</div>
                                                </Form.Group>
                                            </Col>
                                            <Col xs={6} md={3} lg={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Designation</Form.Label>
                                                    <Form.Select className="form-control" name="designation" onChange={handleChange}>
                                                        <option value="0">- Select User Designation -</option>
                                                        {designationData?.Payload?.designationList?.map((result) => {
                                                            return (
                                                                <option value={result.designationId}>{result.designationCode}</option>
                                                            )}
                                                        )}
                                                    </Form.Select>
                                                    <div className="invalid-feedback">{errors["designation"]}</div>
                                                </Form.Group>
                                            </Col>
                                            <Col xs={6} md={3} lg={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Zone</Form.Label>
                                                    <Form.Select className="form-control" name="zone"  onChange={handleChange}>
                                                        <option value="0">- Select Zone -</option>
                                                        {zoneData?.Payload?.zoneMstList?.map((result) => {
                                                            return (
                                                                <option value={result.zoneMstId}>{result.zoneName}</option>
                                                            )}
                                                        )}
                                                    </Form.Select>
                                                    <div className="invalid-feedback">{errors["zone"]}</div>
                                                </Form.Group>
                                            </Col>
                                            <Col xs={6} md={3} lg={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Sub Zone</Form.Label>
                                                    <Form.Control name="subZone" value={subZoneName} type="text" className="form-control" placeholder="Sub Zone" onChange={handleChange}/>
                                                </Form.Group>
                                            </Col>
                                            <Col xs={6} md={3} lg={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Location</Form.Label>
                                                    <Form.Select className="form-control" name="location" onChange={handleChange}>
                                                        <option value="0">- Select Location -</option>
                                                        {locationBasedOnZoneData?.Payload?.locationMstList?.map((result) => {
                                                            return (
                                                                <option value={result.locationId}>{result.locationName}</option>
                                                            )}
                                                        )}
                                                    </Form.Select>
                                                    <div className="invalid-feedback">{errors["location"]}</div>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={12} md={12} lg={12} className="text-right mt-2">
                                                <Button type="button" className="btn btn-sm btn-primary dt float-left shadow-sm" onClick={()=>handlePreviousTabClick ("first")}>Previous</Button>
                                                <Button type="button" className="btn btn-sm btn-primary dt shadow-sm" onClick={()=>{companyDetailsSave();}}>Next</Button>
                                            </Col>
                                        </Row>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="third">
                                        <Row>
                                        <Col xs={6} md={3} lg={3}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>GRN creation rights at HO</Form.Label>
                                                <Form.Select name="GRNatHO" className="form-control"  onChange={handleChange}>
                                                    <option value="0" >- Select Creation Rights -</option>
                                                    <option value="Y">Active</option>
                                                    <option value="N">Inactive</option>
                                                </Form.Select>
                                                <div className="invalid-feedback">{errors["GRNatHO"]}</div>
                                            </Form.Group>
                                        </Col>
                                        <Col xs={6} md={3} lg={3}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>GRN creation rights at zone</Form.Label>
                                                <Form.Select name="GRNatZone" className="form-control"  onChange={handleChange}>
                                                    <option value="0" >- Select Creation Rights -</option>
                                                    <option value="Y">Active</option>
                                                    <option value="N">Inactive</option>
                                                </Form.Select>
                                                <div className="invalid-feedback">{errors["GRNatZone"]}</div>
                                            </Form.Group>
                                        </Col>
                                        <Col xs={6} md={3} lg={3}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>GRN creation rights at location</Form.Label>
                                                <Form.Select name="GRNatLocation" className="form-control"  onChange={handleChange}>
                                                    <option value="0" >- Select Creation Rights -</option>
                                                    <option value="Y">Active</option>
                                                    <option value="N">Inactive</option>
                                                </Form.Select>
                                                <div className="invalid-feedback">{errors["GRNatLocation"]}</div>
                                            </Form.Group>
                                        </Col>
                                            <Col xs={6} md={3} lg={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Functional Reporting</Form.Label>
                                                    <Form.Select className="form-control" name="functionalReporting" onChange={handleChange}>
                                                        <option value="0">- Select Reporting To -</option>
                                                        {ReportingData?.Payload?.employeeList?.map((result) => {
                                                            return (
                                                                <option value={result.employeeId}>{result.employeeName}</option>
                                                            )}
                                                        )}
                                                    </Form.Select>
                                                    <div className="invalid-feedback">{errors["functionalReporting"]}</div>
                                                </Form.Group>
                                            </Col>
                                            <Col xs={6} md={3} lg={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Admin Reporting</Form.Label>
                                                    <Form.Select className="form-control" name="adminReporting" onChange={handleChange}>
                                                        <option value="0">- Select Admin Reporting -</option>
                                                        {ReportingData?.Payload?.employeeList?.map((result) => {
                                                            return (
                                                                <option value={result.employeeId}>{result.employeeName}</option>
                                                            )}
                                                        )}
                                                    </Form.Select>
                                                    <div className="invalid-feedback">{errors["adminReporting"]}</div>
                                                </Form.Group>
                                            </Col>
                                            <Col xs={6} md={3} lg={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Approval Seniority</Form.Label>
                                                    <Form.Select className="form-control" name="approvalSeniority" onChange={handleChange}>
                                                        <option value="0">- Select Approval Seniority -</option>
                                                        {approvalSeniorityData?.Payload?.gradeList?.map((result) => {
                                                            return (
                                                                <option value={result.gradeId}>{result.gradeName}</option>
                                                            )}
                                                        )}
                                                    </Form.Select>
                                                    <div className="invalid-feedback">{errors["approvalSeniority"]}</div>
                                                </Form.Group>
                                            </Col>
                                            <Col xs={12} md={12} lg={12} className="text-right mt-2">
                                                <Button type="button" className="btn btn-sm btn-primary dt float-left shadow-sm" onClick={()=>handleNextTabClick ("second")}>Previous</Button>
                                                <Button type="button" className="btn btn-sm btn-primary dt shadow-sm" onClick={()=>{reportingDetailsSave();}}>Next</Button>
                                            </Col>
                                        </Row>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="fourth">
                                        <Row>
                                            <Col xs={6} md={3} lg={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Assign Roles</Form.Label>
                                                    <Multiselect
                                                        name='role'
                                                        options={roleBasedOnCompanyData?.Payload?.roleList}
                                                        displayValue='roleName'
                                                        onSelect={onSelect}
                                                        onRemove={onRemove}
                                                    />
                                                </Form.Group>
                                                <div className="invalid-feedback">{errors["role"]}</div>
                                            </Col>
                                            <Col xs={12} md={12} lg={12} className="text-right mt-2">
                                                <Button type="button" className="btn btn-sm btn-primary dt float-left shadow-sm" onClick={()=>handleNextTabClick ("third")}>Previous</Button>
                                                <Button type="button" className="btn btn-sm btn-danger dt ml-2 shadow-sm" onClick={() => closePopup()}>Cancel</Button>
                                                <Button type="button" className="btn btn-sm btn-primary dt ml-2 shadow-sm" id="saveTenantUser" onClick={() => saveTabDetails()}>Save & Submit</Button>
                                            </Col>
                                        </Row>
                                    </Tab.Pane>
                                </Tab.Content>
                            </Col>
                        </Row>
                    </Tab.Container>
                </Container>
                <Loader showLoader={showLoader} />
            </Modal.Body>
        </Modal>
    )
}
export default AddTenantUser;